import { createContext, useCallback, useContext, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  // null = checking session, false = signed out, object = signed in
  const [user, setUser] = useState(null);

  useEffect(() => {
    // CRITICAL: If returning from the OAuth callback, skip the /me check —
    // AuthCallback exchanges the session_id and establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    (async () => {
      try {
        let res = await fetch(`${API}/api/auth/me`, { credentials: "include" });
        if (res.status === 401) {
          const r = await fetch(`${API}/api/auth/refresh`, { method: "POST", credentials: "include" });
          if (r.ok) res = await fetch(`${API}/api/auth/me`, { credentials: "include" });
        }
        setUser(res.ok ? await res.json() : false);
      } catch {
        setUser(false);
      }
    })();
  }, []);

  const signout = useCallback(async () => {
    try {
      await fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include" });
    } catch {
      /* network hiccup — clear locally anyway */
    }
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, signout }}>{children}</AuthContext.Provider>;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
